import './App.css'
import { BrowserRouter, Navigate, Route, Routes } from 'react-router-dom'
import { Provider } from 'react-redux'
import {
  applyMiddleware,
  compose,
  legacy_createStore as createStore
} from 'redux'
import { thunk } from 'redux-thunk'
// import { createLogger } from 'redux-logger'
import reducers from './reducers'
import { ToastContainer } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import UnProtectedRoutes from './middlewares/UnProtectedRoutes'
import Login from './screens/login/Login'
import ProtectedRoutes from './middlewares/ProtectedRoutes'
import Signup from './screens/signup/Signup'
import ActivateAccount from './screens/signup/ActivateAccount'
import AccountCreated from './screens/signup/AccountCreated'
import { theme } from './utils/AppColors'
import { ThemeProvider } from '@mui/material'
import SearchJob from './screens/recruiter/jobs/jobsSearch/SearchJob'
import { CssBaseline } from '@mui/material'
import PostNewJob from './screens/employer/jobs/postjob/PostNewJob'
import ManageJob from './screens/employer/jobs/manageJobs/ManageJob'
import JobDetails from './screens/employer/jobs/JobDetails'
import ManageUsers from './screens/employer/subEmployers/ManageUsers'
import NewCompany from './screens/recruiter/jobs/NewCompany'
import ReferralEarning from './screens/recruiter/ReferralEarning'
import { useEffect } from 'react'
import DashboardEmployer from './screens/employer/employerDashboard/DashboardEmployer'
import DashboardRecruiter from './screens/recruiter/dashboard/DashboardRecruiter'
import Worklist from './screens/recruiter/jobs/Worklist'
import WorkedOn from './screens/recruiter/jobs/WorkedOn'
import { LocalizationProvider } from '@mui/x-date-pickers'
import { AdapterDayjs } from '@mui/x-date-pickers/AdapterDayjs'
import SetPasswordSubEmployer from './screens/signup/SetPasswordSubEmployer'
import ApproveCandidate from './screens/recruiter/candidateApprove/ApproveCandidate'
import TrackCandidate from './screens/recruiter/jobs/TrackCandidates/TrackCandidate'
import RejectCandidate from './screens/recruiter/RejectCandidate'
import EditProfile from './screens/employer/edit_profile/EditProfile'
import TakeAction from './screens/employer/employerDashboard/TakeAction'
import ResetPassword from './screens/ResetPassword'
import Notifications from './screens/notificationUI/Notifications'
import EditPreferences from './screens/recruiter/EditPreferences'
import Transactions from './screens/employer/transactions/Transactions'
import RecruiterEditProfile from './screens/recruiter/editProfile/RecruiterEditProfile'
import FAQ from './screens/faq/FAQ'
import CommonRoutes from './middlewares/CommonRoutes'
import ChangePassword from './commonComponents/ChangePassword'
import { ENV } from './ENV'
import EarningsList from './commonComponents/ResponsiveComponents/EarningsList'
import EarningDetails from './commonComponents/ResponsiveComponents/EarningDetails'

// const logger = createLogger()
export const store = createStore(reducers, compose(applyMiddleware(thunk)))

function App () {
  // To update title & favicon
  useEffect(() => {
    document.title = ENV.product_name
    let link =
      document.querySelector('link[rel="shortcut icon"]') ||
      document.querySelector('link[rel="icon"]')

    if (!link) {
      link = document.createElement('link')
      link.id = 'favicon'
      link.rel = 'shortcut icon'
      document.head.appendChild(link)
    }

    link.href = ENV.product_logo
  }, [])
  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />
      <Provider store={store}>
        <LocalizationProvider dateAdapter={AdapterDayjs}>
          <ToastContainer />

          <BrowserRouter>
            <Routes>
              {/* Common routes */}
              <Route path='/activateaccount' element={<ActivateAccount />} />

              <Route
                exact
                path='/setpassword'
                element={<SetPasswordSubEmployer />}
              />

              <Route
                exact
                path='/approvecandidateapplication'
                element={<ApproveCandidate />}
              />

              <Route
                exact
                path='/rejectcandidateapplication'
                element={<RejectCandidate />}
              />

              {/* Unprotected routes- Used if user already logged in, should not be able to access login page */}
              <Route
                exact
                path='/login'
                element={<UnProtectedRoutes component={<Login />} />}
              />
              <Route
                exact
                path='/resetpassword'
                element={<UnProtectedRoutes component={<ResetPassword />} />}
              />

              <Route
                exact
                path='/signup'
                element={<UnProtectedRoutes component={<Signup />} />}
              />

              <Route
                exact
                path='/faq'
                element={<CommonRoutes component={<FAQ />} />}
              />

              <Route path='/recruiter/*'>
                <Route path='*' element={<Navigate replace to='/login' />} />

                <Route
                  exact
                  path='dashboard'
                  element={
                    <ProtectedRoutes
                      role={'recruiter'}
                      component={<DashboardRecruiter />}
                    />
                  }
                />
                <Route
                  exact
                  path='newsearch'
                  element={
                    <ProtectedRoutes
                      componentStyle={{ padding: 0 }}
                      role={'recruiter'}
                      component={<SearchJob />}
                    />
                  }
                />
                <Route
                  exact
                  path='newcompany'
                  element={
                    <ProtectedRoutes
                      role={'recruiter'}
                      component={<NewCompany />}
                    />
                  }
                />
                <Route
                  exact
                  path='referralearning'
                  element={
                    <ProtectedRoutes
                      role={'recruiter'}
                      component={<ReferralEarning />}
                    />
                  }
                />
                <Route
                  exact
                  path='worklist'
                  element={
                    <ProtectedRoutes
                      role={'recruiter'}
                      component={<Worklist />}
                    />
                  }
                />
                <Route
                  exact
                  path='workedon'
                  element={
                    <ProtectedRoutes
                      role={'recruiter'}
                      component={<WorkedOn />}
                    />
                  }
                />

                <Route
                  exact
                  path='trackcandidate'
                  element={
                    <ProtectedRoutes
                      role={'recruiter'}
                      component={<TrackCandidate />}
                    />
                  }
                />
                <Route
                  exact
                  path='notification'
                  element={
                    <ProtectedRoutes
                      role={'recruiter'}
                      component={<Notifications />}
                    />
                  }
                />
                <Route
                  exact
                  path='editprofile'
                  element={
                    <ProtectedRoutes
                      role={'recruiter'}
                      component={<RecruiterEditProfile />}
                    />
                  }
                />
                <Route
                  exact
                  path='editpreferences'
                  element={
                    <ProtectedRoutes
                      role={'recruiter'}
                      component={<EditPreferences />}
                    />
                  }
                />

                <Route
                  exact
                  path='changepassword'
                  element={
                    <ProtectedRoutes
                      role={'recruiter'}
                      component={<ChangePassword />}
                    />
                  }
                />

                <Route
                  exact
                  path='earningsList'
                  element={
                    <ProtectedRoutes
                      role={'recruiter'}
                      component={<EarningsList />}
                    />
                  }
                />

                <Route
                  exact
                  path='earningDetails'
                  element={
                    <ProtectedRoutes
                      role={'recruiter'}
                      component={<EarningDetails />}
                    />
                  }
                />
              </Route>

              <Route path='/employer/*'>
                <Route path='*' element={<Navigate replace to='/login' />} />

                <Route
                  exact
                  path='dashboard'
                  element={
                    <ProtectedRoutes
                      role={'employer'}
                      component={<DashboardEmployer />}
                    />
                  }
                />
                <Route
                  exact
                  path='accountcreated'
                  element={
                    <ProtectedRoutes
                      role={'employer'}
                      component={props => <AccountCreated />}
                    />
                  }
                />

                <Route
                  exact
                  path='postnewjob'
                  element={
                    <ProtectedRoutes
                      role={'employer'}
                      component={props => <PostNewJob {...props} />}
                    />
                  }
                />

                <Route
                  exact
                  path='managejob'
                  element={
                    <ProtectedRoutes
                      role={'employer'}
                      component={props => <ManageJob {...props} />}
                    />
                  }
                />

                <Route
                  exact
                  path='jobdetails'
                  element={
                    <ProtectedRoutes
                      role={'employer'}
                      component={<JobDetails />}
                    />
                  }
                />

                <Route
                  exact
                  path='manageusers'
                  element={
                    <ProtectedRoutes
                      role={'employer'}
                      isNotAllowedToSubEmployer={true}
                      component={<ManageUsers />}
                    />
                  }
                />

                <Route
                  exact
                  path='editprofile'
                  element={
                    <ProtectedRoutes
                      role={'employer'}
                      isNotAllowedToSubEmployer={true}
                      component={props => <EditProfile {...props} />}
                    />
                  }
                />
                <Route
                  exact
                  path='takeaction'
                  element={
                    <ProtectedRoutes
                      role={'employer'}
                      component={<TakeAction />}
                    />
                  }
                />

                <Route
                  exact
                  path='notification'
                  element={
                    <ProtectedRoutes
                      role={'employer'}
                      isNotAllowedToSubEmployer={true}
                      component={<Notifications />}
                    />
                  }
                />
                <Route
                  exact
                  path='transactions'
                  element={
                    <ProtectedRoutes
                      role={'employer'}
                      isNotAllowedToSubEmployer={true}
                      component={<Transactions />}
                    />
                  }
                />

                <Route
                  exact
                  path='changepassword'
                  element={
                    <ProtectedRoutes
                      role={'employer'}
                      component={<ChangePassword />}
                    />
                  }
                />
              </Route>

              {/* Not found */}
              <Route path='*' element={<Navigate replace to='/login' />} />
            </Routes>
          </BrowserRouter>
        </LocalizationProvider>
      </Provider>
    </ThemeProvider>
  )
}

export default App
